import React from "react";
import Error from "@cdkglobal/epay-admin-component/cjs/components/_onePay/common/error/common/Error";

const SessionTimeout = props => {
  return (
    <Error
      errorStatus={"440"}
      errorText={"OnePay Session has expired"}
      errorDescription={
        "It looks like the OnePay Application session has expired. Please close the tab and reopen the application."
      }
    />
  );
};

export default SessionTimeout;
